import { NumberValue } from '../../../utils'

export const getOptionalNumberValue = (value: string): number | undefined =>
  value === '' ? undefined : new NumberValue(value).getValue()
